export const CALO_SOCIAL_PROOF_COUNT_LONG = "3 Million+";
export const CALO_SOCIAL_PROOF_COUNT_SHORT = "3M+";

export const getCaloUserCountLabel = (count = CALO_SOCIAL_PROOF_COUNT_LONG) => {
    return `${count} Calo users`;
};

export const getUsersChosenUsLabel = (count = CALO_SOCIAL_PROOF_COUNT_SHORT) => {
    return `${count} Users Have Chosen Us`;
};
